<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <div>
          <div>
            <h6 class="heading-small text-muted mb-4">Template</h6>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="selectedAccountReportTemplateId"
                  style="width: 100%"
                  placeholder="Select Template"
                  :filter-option="filterOption"
                  @change="
                    (event) => {
                      setAccountReportTemplate(event);
                      setOrigConfig(event);
                    }
                  "
                >
                  <a-select-option
                    v-for="template in options.accountReportTemplates"
                    :value="template.id"
                    :key="template.id"
                    :label="template.name"
                  >
                    {{ template.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </div>
        <br />
        <form role="form" @submit.prevent>
          <h6 class="heading-small text-muted mb-4">Filters</h6>
          <div>
            <div>
              <label>Membership Program</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.membership_programs"
                  mode="multiple"
                  style="width: 100%"
                  placeholder="Select Membership Programs"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="opt in options.membership_programs"
                    :value="opt.id"
                    :key="opt.id"
                    :label="opt.name"
                  >
                    {{ opt.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>Interaction types</label>
            </div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.interaction_types"
                  mode="multiple"
                  style="width: 100%"
                  placeholder="Select Interaction Types"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="opt in options.interaction_types"
                    :value="opt.id"
                    :key="opt.id"
                    :label="opt.name"
                  >
                    {{ opt.name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <base-button
                type="primary btn-block"
                class="my-4"
                @click.prevent="setFilter"
              >
                <div>Apply Filter</div>
              </base-button>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.appendedParams"
          :sortOrder="table.sortOrder"
          :sortParams="getSortParam"
          :multiSort="table.multiSort"
          :multiSortKey="table.multiSortKey"
        >
          <template #headerButtons>
            <div>
              <b-button
                v-if="selectedActions.includes('Customize')"
                variant="primary"
                @click.prevent="openDrawer('report_template')"
                >Customize</b-button
              >
              <b-button
                v-if="
                  selectedActions.includes('Download') ||
                  selectedActions.includes('Send')
                "
                variant="danger"
                @click.prevent="openDrawer('export_data')"
                >Export</b-button
              >
            </div>
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <AccountReportTemplate
                v-if="drawer.action == 'report_template'"
                :accountReport="accountReport"
                :accountReportTemplate="accountReportTemplate"
                :selectedAccountReportTemplateColumns="tableFields"
                :selectedAccountReportTemplateFilters="table.appendedParams"
                :selectedAccountReportTemplateSorts="table.sortOrder"
                :updatedFilter="updatedFilters"
                @setTableColumns="setTableColumns"
                @setAccountReportTemplate="getAccountReportData"
                @deleteAccountReportTemplate="getAccountReportData"
                @closeDrawer="closeDrawer"
                @setUpdatedFilter="updatedFilters = false"
              />

              <ExportDataForm
                v-if="drawer.action == 'export_data'"
                :template="selectedAccountReportTemplateId"
                :jsonFields="toJsonFields"
                :filename="filename"
                :apiUrl="tableApiUrl"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import HTTPRequest from '../../../controllers/httpRequest';
import PageHeader from '../../../components/Page/Header.vue';
import PageContent from '../../../components/Page/Content.vue';
import PageTable from '../../../components/Page/Table.vue';
import AccountReportTemplate from '../Drawers/AccountReportTemplateForm.vue';
import ExportDataForm from '../Drawers/ExportDataForm.vue';
import { mapGetters } from 'vuex';
import '@/assets/css/custom.css';
import moment from 'moment-timezone';
const ENV = process.env.VUE_APP_ENV;
const TIMEZONE = process.env.VUE_APP_TIMEZONE || 'Asia/Singapore';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    AccountReportTemplate,
    ExportDataForm
  },
  data() {
    return {
      filename: `Report - ${moment().format('YYYY-MM-DDTHHmmss.SSS')}.csv`,
      updatedFilters: false,
      originalFilter: null,
      gradientType: 'gradient-yellow',
      accountReport: null,
      accountReportTemplate: null,
      selectedAccountReportTemplateId: null,
      saveFilters: false,
      saveSorts: false,
      drawer: {
        visible: false,
        width: 600,
        placement: 'right',
        action: null
      },
      table: {
        title: 'Customers Interaction Reports',
        apiUrl: '/api/v1/reports/customers_interaction',
        fields: [],
        appendedParams: {
          membership_programs: [],
          interaction_types: [],
          report_type: 'list',
          export_data: false,
          filter: false
        },
        multiSort: true,
        multiSortKey: 'alt',
        sortOrder: null
      },
      options: {
        membership_programs: [],
        interaction_types: [],
        reportTypes: [{ id: 'list', name: 'Listing' }],
        reportTemplates: [],
        accountReportTemplates: null
      }
    };
  },
  methods: {
    filterOption(inputValue, option) {
      return (
        option?.componentOptions?.propsData?.label
          .toLowerCase()
          .indexOf(inputValue.toLowerCase()) !== -1
      );
    },
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.options.membership_programs = response.data;
    },

    async getInteractionTypes() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_interaction_types'
      );
      this.options.interaction_types = response.data;
    },

    async getAccountReportData() {
      let accountReport = [];

      accountReport = await HTTPRequest.getRequest(
        '/api/v1/account_reports/CUSTOMER_INTERACTION_LOGS_REPORTS_LIST/default'
      );
      this.accountReport = accountReport;
      await this.setAccountReportTemplate(
        accountReport.accountReportTemplates[0]
      );
      this.setOrigConfig(accountReport.accountReportTemplates[0]);
      await this.getAccountReportTemplates();
    },
    async getAccountReportTemplates() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/account_report_templates/' +
          this.accountReport.code +
          '/templates'
      );
      this.options.accountReportTemplates = data;
    },

    setAccountReportTemplate(accountReportTemplate) {
      let accountReportTemplateData;
      if (typeof accountReportTemplate == 'number') {
        this.selectedAccountReportTemplateId = accountReportTemplate;
        for (const template of this.options.accountReportTemplates) {
          if (accountReportTemplate == template.id) {
            this.accountReportTemplate = template;
            accountReportTemplateData = JSON.parse(template.config);
          }
        }
      } else {
        this.accountReportTemplate = accountReportTemplate;
        accountReportTemplateData = JSON.parse(accountReportTemplate.config);
        this.selectedAccountReportTemplateId = accountReportTemplate.id;
      }

      /** Clear the previous' template's filter/s */
      this.clearTableFilters();

      /** Clear the previous' template's sort/s */
      this.clearTableSorts();

      /** Load template's default columns */
      this.setTableColumns(accountReportTemplateData.columns);

      if (
        accountReportTemplateData.filters &&
        Object.keys(accountReportTemplateData.filters).includes('source')
      ) {
        const spreadFilter = { ...accountReportTemplateData.filters };
        delete spreadFilter['source'];
        accountReportTemplateData.filters = spreadFilter;
      }
      /** Load template's default filters */
      this.setTableFilters(accountReportTemplateData.filters);

      /** Load template's default sort */
      this.setTableSorts(accountReportTemplateData.sorts);
    },

    setTableColumns(columns = []) {
      /**
       * Note: Amongst the other 2 methods on clearing the table fields,
       * this one worked as this doesn't alter the original array instance
       *
       * this.table.fields = this.table.fields.splice(0, this.table.fields.length);
       * this.table.fields = [];
       * */
      /** Clear table fields */
      this.table.fields.length = 0;

      const tableFields = this.table.fields;

      columns.forEach((column) => {
        /** Check if current "column" is already in the table */ ``;
        let hasField = tableFields.find((field) => field.name === column.name);

        if (typeof hasField === 'undefined') {
          if (Object.keys(column).includes('value')) {
            if (column.value) {
              /** Push to table */
              if (column.name == 'date_submitted') {
                column.formatter = function (date) {
                  if (moment(date).isValid()) {
                    if (ENV === 'development') {
                      return moment(date).format('YYYY-MM-DD h:mm A');
                    } else {
                      return moment
                        .utc(date)
                        .tz(TIMEZONE)
                        .format('YYYY-MM-DD h:mm A');
                    }
                  }
                  return null;
                };
              }
              this.table.fields.push(column);
            }
          } else {
            /** Push to table */
            if (column.name == 'date_submitted') {
              column.formatter = function (date) {
                if (moment(date).isValid()) {
                  if (ENV === 'development') {
                    return moment(date).format('YYYY-MM-DD h:mm A');
                  } else {
                    return moment
                      .utc(date)
                      .tz(TIMEZONE)
                      .format('YYYY-MM-DD h:mm A');
                  }
                }
                return null;
              };
            }
            this.table.fields.push(column);
          }
        }
      });
    },

    setTableFilters(filters = {}) {
      if (Object.keys(filters).length !== 0) {
        this.table.appendedParams = filters;
        // setTimeout(() => this.setFilter(), 200);
      }
    },

    setTableSorts(sorts = []) {
      if (sorts && sorts.length > 0) {
        this.table.sortOrder = sorts;
        // setTimeout(() => this.setFilter(), 200);
      } else {
        this.table.sortOrder = sorts;
      }
    },

    getSortParam(sortOrder) {
      return sortOrder
        .map(function (sort) {
          return sort.field + '|' + sort.direction;
        })
        .join(',');
    },

    async onChangeReportType() {
      /** Get report data for the report type */
      this.getAccountReportData();

      /** Clear filters for the table */
      this.clearTableFilters();

      /** Reload table */
      this.setFilter();
    },

    clearTableFilters() {
      this.table.appendedParams.membership_programs = [];
      this.table.appendedParams.interaction_types = [];
    },

    clearTableSorts() {
      this.table.sortOrder = null;
    },

    openDrawer(action) {
      this.drawer.visible = true;
      this.drawer.action = action;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.drawer.action = null;
    },

    setFilter() {
      this.table.appendedParams.filter = true;
      this.originalFilter === JSON.stringify(this.table.appendedParams)
        ? (this.updatedFilters = false)
        : (this.updatedFilters = true);
      this.$root.$emit('refreshTable');
    },

    serializeQuery(params, prefix) {
      const query = Object.keys(params).map((key) => {
        if (params[key]) {
          const value = params[key];

          if (params.constructor === Array) {
            key = `${prefix}[]`;
          } else if (params.constructor === Object) {
            key = prefix ? `${prefix}[${key}]` : key;
          }

          if (typeof value === 'object') {
            return this.serializeQuery(value, key);
          } else {
            return `${key}=${encodeURIComponent(value)}`;
          }
        }
      });

      let serializedQuery = query.filter((elem) => elem != '');

      return [].concat.apply([], serializedQuery).join('&');
    },
    setOrigConfig(event) {
      if (typeof event == 'number') {
        for (const template of this.options.accountReportTemplates) {
          if (event == template.id) {
            const jConfig = JSON.parse(template.config);
            if (Object.keys(jConfig).includes('filter')) {
              this.originalFilter = JSON.stringify(
                JSON.parse(jConfig.config).filters
              );
            } else {
              this.originalFilter = JSON.stringify(this.table.appendedParams);
            }
          }
        }
      } else {
        const jConfig = JSON.parse(event.config);
        if (Object.keys(jConfig).includes('filter')) {
          this.originalFilter = JSON.stringify(jConfig.filters);
        } else {
          this.originalFilter = JSON.stringify(this.table.appendedParams);
        }
      }
    }
  },
  created() {
    this.getMembershipPrograms();
    this.getInteractionTypes();

    this.getAccountReportData();

    this.$store.dispatch('setCurrentModule', 'CustomerInteractionReport');
  },
  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  },

  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    }),
    tableFields() {
      const _tableFields = [...this.table.fields];
      return _tableFields;
    },

    tableApiUrl() {
      const tableApiUrl = this.table.apiUrl;
      const _tableParams = { ...this.table.appendedParams };
      _tableParams.export_data = true; // Update to true, for exportable data
      const _tableSort = [...this.table.sortOrder];
      let sorts, filters;

      /** Create query string for "sort" first if there are sorting */
      if (_tableSort.length > 0) {
        let i = 0;
        for (let sort of _tableSort) {
          if (i == 0) {
            sorts = 'sort=' + sort.field + '|' + sort.direction;
          } else {
            sorts += ',' + sort.field + '|' + sort.direction;
          }
          i++;
        }
      }

      /** Parse object for query string */
      filters = this.serializeQuery(_tableParams);
      if (tableApiUrl.includes('?')) {
        return tableApiUrl + '&' + sorts + '&' + filters;
      } else {
        return tableApiUrl + '?' + sorts + '&' + filters;
      }
    },

    toJsonFields: function () {
      const _tableFields = [...this.table.fields];
      let jsonFields = {};

      for (let field of _tableFields) {
        jsonFields[field.title] = field.name;
        if (field.name == 'date_submitted') {
          jsonFields[field.title] = {
            field: 'date_submitted',
            callback: (date) => {
              if (moment(date).isValid()) {
                if (ENV === 'development') {
                  return moment(date).format('YYYY-MM-DD h:mm A');
                } else {
                  return moment
                    .utc(date)
                    .tz(TIMEZONE)
                    .format('YYYY-MM-DD h:mm A');
                }
              }
              return null;
            }
          };
        }
      }

      return jsonFields;
    }
  }
};
</script>

<style scoped></style>
